import * as React from 'react';
import { useSelector } from 'react-redux';
import { Text, scrollToElement } from '@siteground/styleguide';
import { getOperatorTypingStatus } from '../../../selectors/operator';
import { ChatContext } from '../../chat-context';
import './operator-typing-indicator.css';

const OperatorTypingIndicator = () => {
  const domRef = React.useRef(null);
  const { shouldAutoScroll } = React.useContext(ChatContext);
  const isOperatorTyping = useSelector(getOperatorTypingStatus);

  React.useEffect(() => {
    if (shouldAutoScroll && isOperatorTyping) {
      scrollToElement(domRef.current, { behavior: 'auto', block: 'start', inline: 'nearest' });
    }
  }, [isOperatorTyping]);

  return (
    <div ref={domRef}>
      {isOperatorTyping && (
        <Text className="operator-typing" color="light">
          <span>&bull;</span>
          <span>&bull;</span>
          <span>&bull;</span>
        </Text>
      )}
    </div>
  );
};

export default OperatorTypingIndicator;
